<template>
    <div class="table-responsive">
    <base-crud
            crudName="Logs de Acesso"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="false"
            :enableEdit="false"
            :enableDelete="false"
            :enableView="true"
            :dataForm="dataForm"
            :customFilters="customFilters"
            @filteredCreatedAt="filteredCreatedAt"
        ></base-crud>
    </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import {addZeros} from "../../composables/functions";

export default {
    data: function () {
        return {
            customFilters: [
                {
                    name: "created_at",
                    type: "calendar",
                    call: "filteredCreatedAt",
                },
            ],
            created_at: '',
            table: "accessLogTable",
            columns: [
                "id",
                "created_at",
                "user_id",
                "email",
                "device",
                "version",
                "so",
                "ip",
            ],
            tableData: [
                "id",
                "created_at",
                "user_id",
                "device",
                "version",
                "so",
                "ip",
            ],
            options: {
                sortable: [
                    "id",
                    "created_at",
                    "user_id",
                ],
                columns: [
                    "id",
                    "created_at",
                    "user_id",
                    "email",
                    "device",
                    "version",
                    "so",
                    "ip",
                ],
                filterByColumn: true,
                debounce: 1000,
                filterable: [
                    "id",
                    "user_id",
                    "email",
                    "device",
                    "version",
                    "so",
                    "ip",
                ],
                pagination: {chunk: 10, dropdown: false, nav: "scroll"},
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    id: "ID",
                    user_id: "Nome do Usuário",
                    email: "E-mail",
                    created_at: "Data",
                    device: 'Dispositivo',
                    version: 'Versão',
                    so: 'Sistema Operacional',
                    ip: 'Endereço IP',
                },
                templates: {
                    user_id: function (h, row, index) {
                        return row.user ? row.user.name : "Erro de login";
                    },
                    created_at: function (h, row, index) {
                        const date = new Date(row.created_at)
                        return `${addZeros(date.getDate())}/${addZeros(date.getMonth() + 1)}/${date.getFullYear()} ${addZeros(date.getHours())}:${addZeros(date.getMinutes())}:${addZeros(date.getSeconds())}`;
                    }
                },
                requestFunction: function (data) {
                    let requestData = {};

                    let query = this.$parent.$parent.query(data.query);

                    requestData.params = data;

                    if (
                        this.$parent.$parent.created_at != null &&
                        this.$parent.$parent.created_at != ""
                    ) {
                        requestData.params.created_at = this.$parent.$parent.created_at;
                        // requestData.params.created_at = `${this.$parent.$parent.created_at},${this.$parent.$parent.created_at}`;
                    }

                    requestData.params.query = "";
                    requestData.params.with = [
                        "user",
                    ];

                    return this.$http.get(this.url + "?" + query, requestData).catch(
                        function (e) {
                            this.dispatch("error", e);
                        }.bind(this)
                    );
                },
            },
            endPoint: "access-logs/",
            dataForm: {},
        };
    },
    components: {
        BaseCrud,
    },
    methods: {
        filteredCreatedAt(date) {
            this.created_at = date;
        },
        query: function (query) {
            let columns = {
                id: "id",
                created_at: "created_at",
                user_id: "user[name]",
                email: 'email',
                device: 'device',
                version: 'version',
                so: 'so',
                ip: 'ip',
            };

            let filters = "orderByDesc=created_at&";

            $.each(query, function (index, value) {
                filters += columns[index] + "=" + value + "&";
            });
            return filters;
        },

    },
};
</script>

<style scoped>
.VuePagination {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/AccessLog/Index.vue